import { render, staticRenderFns } from "./SiderTrigger.vue?vue&type=template&id=4947a3f6&scoped=true"
import script from "./SiderTrigger.vue?vue&type=script&lang=js"
export * from "./SiderTrigger.vue?vue&type=script&lang=js"
import style0 from "./SiderTrigger.vue?vue&type=style&index=0&id=4947a3f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4947a3f6",
  null
  
)

export default component.exports